import React, { FunctionComponent } from "react";
import { Button } from "@plex/react-components";
import { IViewController, useViewController } from "../ViewContext";
import "./UserDefinedSchemaEditor.scss";
import { isFeatureToggleOn, setSchemaIdForLoopEndVariables } from "../Util/NodeUtil";
import { getLoopVariableSchemaId, addSchema, schemaExists } from "../NodeTypes/DataSchemas";
import { DocumentSchemaType, IDocumentObjectSchema, ObjectSchemaTags } from "../FlowDocument/FlowDocumentModel";
import { DocumentSchemaSource } from "../NodeTypes/Base";
import { useReactFlow, useUpdateNodeInternals } from "reactflow";
import { updateLinkedSchemas } from "../Util/EdgeUtil";

export interface ILoopVariableEditorProps {
  nodeId: string;
  onClose?: () => void;
}

export const variablesPropertyLabel = "Variables";
export const variableInPropertyName = "variablesIn";
export const variableOutPropertyName = "variablesOut";

export const LoopVariableEditor: FunctionComponent<ILoopVariableEditorProps> = (props) => {
  const reactFlowInstance = useReactFlow();
  const updateNodeInternals = useUpdateNodeInternals();
  const {
    userDefinedSchemasEditorState,
    setUserDefinedSchemasEditorState,
    setUserDefinedSchemaDetailsDialogState
  }: IViewController = useViewController();

  if (!isFeatureToggleOn("feat-core-3422-flows-loop-variables")) {
    return <></>;
  }

  const openSchemaEditor = () => {
    const schemaId = getLoopVariableSchemaId(props.nodeId);
    if (!schemaExists(schemaId)) {
      const newSchema: IDocumentObjectSchema = {
        id: schemaId,
        schemaType: DocumentSchemaType.object,
        properties: {},
        tags: [ObjectSchemaTags.userDefinedSchema, ObjectSchemaTags.loopVariableSchema]
      };
      addSchema(newSchema, DocumentSchemaSource.userDefined, schemaId);
      const node = reactFlowInstance.getNode(props.nodeId);
      if (node) {
        node.data.nodeProperties.inputs[variableInPropertyName].schemaId = schemaId;
        node.data.nodeProperties.outputs[variableOutPropertyName].schemaId = schemaId;
        setSchemaIdForLoopEndVariables(reactFlowInstance, updateNodeInternals);
        updateLinkedSchemas(
          reactFlowInstance.getNodes(),
          reactFlowInstance.getEdges(),
          updateNodeInternals,
          reactFlowInstance
        );
      }
    }
    setUserDefinedSchemasEditorState({
      show: false,
      selectedSchemaId: schemaId,
      selectedSchemaName: schemaId,
      selectedSchemaInUse: false
    });
    setUserDefinedSchemaDetailsDialogState({
      show: true,
      schemaName: schemaId,
      schemaInUse: false,
      loopVariable: true,
      loopNodeId: props.nodeId
    });
  };

  return (
    <div>
      <Button className="plex-fd-edit-objects-button" onClick={openSchemaEditor}>
        Edit Variables
      </Button>
      <Button
        className="plex-fd-edit-objects-button"
        onClick={() =>
          setUserDefinedSchemasEditorState({
            ...userDefinedSchemasEditorState,
            show: true
          })
        }
      >
        Edit User Objects
      </Button>
    </div>
  );
};
